export function getBooleanStringValue(value) {
    return value ? 'yes' : 'no';
}
